module.exports = __webpack_public_path__ + "img/message_empty.723c6961.png";